



































import { Component, Inject } from 'vue-property-decorator';
import Cheeers3Icon from '@/components/Helper/Icon/Svg/Cheeers3Icon.vue';
import ThanksMessageMixin from './thanks-message.mixin';
import ThanksMessageListPc from './ThanksMessageList/ThanksMessageListPc.vue';

@Component<ThanksMessagePc>({
  components: { Cheeers3Icon, ThanksMessageListPc },
})
export default class ThanksMessagePc extends ThanksMessageMixin {
  @Inject('toggleSideDrawer')
  toggleSideDrawer!: () => any;
  delayTimer = null;
  keywords = null;

  /**
   * search after stop typing thanks messages
   */
  search() {
    clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => {
        this.keySearch = this.keywords;
      }, 500);
  }
}
